export const VUEX_GLOBAL_ACTION_PROMPT_YES = 'VUEX_GLOBAL_ACTION_PROMPT_YES'
export const VUEX_GLOBAL_ACTION_PROMPT_NO = 'VUEX_GLOBAL_ACTION_PROMPT_NO'
export const VUEX_GLOBAL_ACTION_PROMPT_CLOSEX = 'VUEX_GLOBAL_ACTION_PROMPT_CLOSEX'
export const VUEX_GLOBAL_ACTION_PROMPT_SHOW = 'VUEX_GLOBAL_ACTION_PROMPT_SHOW'
export const VUEX_GLOBAL_ACTION_PROMPT_CLOSED = 'VUEX_GLOBAL_ACTION_PROMPT_CLOSED'
export const VUEX_GLOBAL_ACTION_PROMPT_SET_ACTION_OBJECT = 'VUEX_GLOBAL_ACTION_PROMPT_SET_ACTION_OBJECT'
export const VUEX_GLOBAL_ACTION_PROMPT_SET_STATE_CHANGE_WATCHERS = 'VUEX_GLOBAL_ACTION_PROMPT_SET_STATE_CHANGE_WATCHERS'
